import {DomainObject} from 'shared/store';
import { observable, computed, makeObservable } from 'mobx';
import TimeOffType from './TimeOffType';
import _ from 'lodash';

class TimeOffAccount extends DomainObject {
  id;
  timeOffType;
  balance;
  unlimited;

  _relations = {
    timeOffType: TimeOffType
  };

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      timeOffType: observable,
      balance: observable,
      unlimited: observable,
      balanceView: computed,
      isNegativeBalance: computed,
      balanceDescription: computed
    });

    this.merge(other);
  }

  get balanceView() {
    if (this.unlimited) return '--';

    return this.balance;
  }

  get isNegativeBalance() {
    if (this.unlimited) return false;

    return this.balance < 0;
  }

  get balanceDescription() {
    return this.unlimited ? 'employees.profile.time_off.Flexible' : `employees.profile.time_off.${_.startCase(this.timeOffType.unit)} Available`;
  }
}

export default TimeOffAccount;
